import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Circle = styled('div')<{
    width?: string
    theme?: TTheme
}>`
    display: flex;
    align-self: center;
    background-color: ${({ theme }) => `${theme.colors.greys[500]}`};
    width: ${({ width }) => `${width || '5px'}`};
    aspect-ratio: 1;
    border-radius: 50%;
`
